import { CanalVentaForm, Licencia, LicenciaForm, LocalCanalConfiguracion } from '@models/.';
import { transformLicenseForm } from '..';
import { LicenciaResumenForm } from '@core/models/licencia';
import { PlatformLicenseEnum } from '@core/enums';

export function transformSummaryToForm(
  licenses?: Licencia[],
  salesChannels: CanalVentaForm[] = [],
  storeChannels: LocalCanalConfiguracion[] = [],
): LicenciaResumenForm[] {
  const elements: LicenciaResumenForm[] = [];
  const hasLicensesPlatform: PlatformLicenseEnum[] = [
    PlatformLicenseEnum.JuvoPos,
    PlatformLicenseEnum.JuvoKiosk,
    PlatformLicenseEnum.JuvoKDS,
  ];
  const customOrder = [
    PlatformLicenseEnum.JuvoPos,
    PlatformLicenseEnum.JuvoKiosk,
    PlatformLicenseEnum.JuvoKDS,
  ];

  (licenses ?? []).map((license) => {
    const storeChannelId = license.localCanalId;
    let element = elements.find((e) => e.localCanalId === storeChannelId);

    if (!element) {
      element = {
        name: license.nombrelocalCanal,
        enabled: false,
        hasLicenses: false,
        licenses: [],
        totalAvailable: 0,
        totalNotAvailable: 0,
        total: 0,
        totalCurrent: 0,
        totalCurrentAvailable: 0,
        totalNewLicenses: 0,
        totalRemovedLicenses: [],
        localCanalId: storeChannelId,
      };

      elements.push(element);
    }

    element.licenses.push(transformLicenseForm(license) as LicenciaForm);
  });

  return salesChannels && !!salesChannels.length
    ? (salesChannels ?? [])
      .filter(({ code }) => ![PlatformLicenseEnum.JuvOffice].includes(code as PlatformLicenseEnum))
      .map((channel) => {
        const element = elements.find((e) => e.name === channel.code);
        const storeChannel = storeChannels.find(((e) => e.canalId === channel.id));
        const saleChannel = salesChannels.find(((e) => e.code === channel.code));
        
        return {
          ...channel,
          ...element,
          localCanalId: storeChannel?.idLocalCanal,
          channelId: saleChannel?.id,
          hasLicenses: !!hasLicensesPlatform.includes(
            channel.name as PlatformLicenseEnum
          ),
          enabled: storeChannel?.habilitado ?? false,
          ...(element?.licenses ?? []).reduce(
            (acc, license) => {
              if (license.available) acc.totalAvailable += 1;
              else acc.totalNotAvailable += 1;

              acc.total += 1;
              acc.totalCurrent = acc.total;
              acc.totalCurrentAvailable = acc.totalAvailable;

              return acc;
            },
            { totalAvailable: 0, totalNotAvailable: 0, total: 0, totalCurrent: 0, totalCurrentAvailable: 0, totalRemovedLicenses: [] }
          ),
        } as LicenciaResumenForm;
      }).sort((a, b) => {
        const indexA = customOrder.indexOf(a.name as PlatformLicenseEnum);
        const indexB = customOrder.indexOf(b.name as PlatformLicenseEnum);
        
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        
        return 0;
      })
    : elements;
}